<!-- Originally we had ag-grid fixed height set to 300px, regardless of row number
To avoid empty space in bottom area, if row count is less than 8 (this fits in 300px), height is calculated automatically -->
<ag-grid-angular
  [domLayout]="bookingApprovalsHistory.length > 8 ? 'normal' : 'autoHeight'"
  [style.height]="bookingApprovalsHistory.length > 8 ? '300px' : 'none'"
  [gridOptions]="gridOptions"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [suppressContextMenu]="true"
  (gridReady)="onGridReady($event)"
  (gridSizeChanged)="onGridSizeChanged($event)"
  class="ag-theme-alpine_customize"
  style="width: 100%"></ag-grid-angular>
